import React from 'react';
import PropTypes from 'prop-types';
import './ListBase.scss';

const ListBase = ({
  children,
}) => (
  <div className="list-base">
    {children}
  </div>
);

ListBase.propTypes = {
  children: PropTypes.node.isRequired,
};

ListBase.defaultProps = {

};

export default ListBase;
